export default {
  title: "Discard Performed Work",
  content:
    'Are you sure you want to discard this <b class="text-info">Performed Work</b>? <br><br> Any attached photographs will be deleted.',
}
